/*
 * @Description  : 专家维护 -- 基础库管理（待完善）
 * @Author       : zhanglei
 * @Date         : 2025-05-15 10:49:37
 * @LastEditors  : zhanglei
 * @LastEditTime : 2025-05-15 10:51:31
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\expert_gz_new.js
 */
import request from '../request.js'

// 基础库管理（待完善）-分页-----朱新宇
export const getPage = function (data) {
    return request({
        url: '/expertApply/page',
        method: 'post',
        data
    })
}

// 基础库管理（待完善）-保存跟进记录-----朱新宇
export const followApply = function (data) {
    return request({
        url: '/expertApply/followApply',
        method: 'post',
        data
    })
}

// 基础库管理（待完善）-跟进记录信息-----朱新宇
export const followDetail = function (data) {
    return request({
        url: '/expertApply/followDetail',
        method: 'post',
        data
    })
}
